import script from "./ProjectCompetenceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCompetenceCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCompetenceCard.vue?vue&type=style&index=0&id=2abf0515&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2abf0515"]])

export default __exports__